import React, { Fragment } from 'react';
import Stack from '@mui/material/Stack';

import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';

export const LoadingServiceContent = () => {
  return (
    <Stack sx={{ width: '100%' }}>
      {[1, 2, 3].map((n: number) => (
        <Fragment key={n}>
          <Skeleton shape='title' />
          <Skeleton shape='paragraph' />
          <Skeleton shape='subtitle' />
          <Skeleton shape='paragraph' />
        </Fragment>
      ))}
    </Stack>
  );
};

export default LoadingServiceContent;
